class PagedListUtility {
  static toPagedList(items, pageNumber, pageSize) {
    items = items !== null && items !== void 0 ? items : [];
    if (pageSize <= 0) {
      pageSize = Number.MAX_SAFE_INTEGER;
    }
    const totalItemCount = items.length;
    let pageCount = Math.trunc(totalItemCount / pageSize);
    if (pageCount === 0) {
      pageCount = 1;
    } else if (totalItemCount > pageCount * pageSize) {
      pageCount++;
    }
    if (pageNumber > pageCount) {
      pageNumber = 1; //pageCount
    }

    const firstIndex = (pageNumber - 1) * pageSize;
    const pageItems = items.slice(firstIndex, firstIndex + pageSize);
    const lastIndex = pageItems.length > 1 ? firstIndex + pageItems.length - 1 : firstIndex;
    return {
      items: pageItems,
      pageSize: pageSize,
      totalItemCount: totalItemCount,
      pageNumber: pageNumber,
      pageCount: pageCount,
      hasPreviousPage: pageNumber > 1,
      hasNextPage: pageNumber < pageCount,
      isFirstPage: pageNumber == 1,
      isLastPage: pageNumber >= pageCount,
      firstItemIndex: firstIndex,
      lastItemIndex: lastIndex
    };
  }
}

const ArrayExtensions = function () {
  if (Array.prototype.toPagedList == null) {
    Array.prototype.toPagedList = function (pageNumber, pageSize) {
      return PagedListUtility.toPagedList(this, pageNumber, pageSize);
    };
  }
};
ArrayExtensions();

export { ArrayExtensions, PagedListUtility };
